package com.appcreator.blueprint.dataspecs

import com.appcreator.blueprint.core.DataSpec
import kotlinx.serialization.Serializable

@Serializable
class UnsupportedDataSpec(override val key: String = "", override val specType: String) : DataSpec {
    override fun copySpec(key: String): DataSpec = throw IllegalStateException()
}
